<template lang="pug">
  div(class="col-6")
    draggable(class="list-group" ghost-class="ghost" v-model="banners" @change="updateOrder")
      transition-group
        .banner-order-plate(v-for="banner in banners" :key="banner.id")
          BannerSortOrderNameplate(:banner="banner" class="list-group-item")
    button(class="btn btn-primary" @click="sendUpdatedOrder") {{ $t('submit') }}
    b-alert(:show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged") {{ $t('banner_ordering_successful') }}
</template>

<script>
import draggable from 'vuedraggable'
import bannerSortOrder from '../shared/services/bannerSortOrder'
import BannerSortOrderNameplate from '../shared/components/BannerSortOrderNameplate'
export default {
  components: {
    BannerSortOrderNameplate,
    draggable
  },
  created() {
    bannerSortOrder.fetchAll()
      .then(response => {
        this.banners = response.data.homepage_banners

      })
  },
  data() {
    return {
      banners: [],
      sortOrder: [],
      dismissSecs: 2,
      dismissCountDown: 0
    }
  },
  methods: {
    updateOrder() {
      this.sortOrder = this.banners.map((banner, index) => { return { id: banner.id, order: index } })
     },
    sendUpdatedOrder() {
      bannerSortOrder.sort(this.sortOrder)
        .then(this.showAlert)
    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>

<style scoped>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .banner-order-plate {
    transition: transform .5s;
  }
</style>
